import React, { useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
// --- Import Components
import Portal from "../../../components/UI/Portal/Portal";
// --- Import Img
import { ReactComponent as ErrorImg } from "../../../assets/images/icons/warning_icon.svg";

import "./RefundErrorModal.sass";

function RefundErrorModal({ isOpen, errorMsg, onCancel }) {
  const modalRef = useRef();

  const handleClick = useCallback(
    (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onCancel();
      }
    },
    [modalRef, onCancel]
  );

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("click", handleClick);
    }
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, [isOpen, onCancel, modalRef, handleClick]);

  return (
    isOpen && (
      <Portal>
        <div className="modalOverlay">
          <div className="modalError" ref={modalRef}>
            <ErrorImg
              style={{ color: "#3683f7", stroke: "#3683f7" }}
              className="modalError__img"
              width="70px"
              height="70px"
            />
            <p className="modalError__text">{errorMsg}</p>
            <button className="modalError__btn" onClick={onCancel}>
              OK
            </button>
          </div>
        </div>
      </Portal>
    )
  );
}

RefundErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  errorMsg: PropTypes.string,
  onCancel: PropTypes.func,
};
RefundErrorModal.defaultProps = {
  isOpen: false,
  errorMsg: "",
  onCancel: () => {},
};
export default RefundErrorModal;
